import React, { useCallback, useState } from "react";
import Button from "../../button";
import styles from "./contact.module.scss";
import Toast from "../../toast/toast";

const socials = [
  {
    label: "GitHub",
    handle: "@matheustsx",
    href: "https://github.com/matheustsx",
  },
  {
    label: "LinkedIn",
    handle: "/in/matheus-batista-chavante",
    href: "https://www.linkedin.com/in/matheus-batista-chavante/",
  },
  {
    label: "Instagram",
    handle: "@matheuss.tsx",
    href: "https://www.instagram.com/matheuss.tsx",
  },
];

type Status = "idle" | "sending" | "success" | "error";

const initialForm = { name: "", email: "", message: "" };

export const Contact = () => {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState<Status>("idle");
  const [feedback, setFeedback] = useState("");

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { id, value } = event.target;
    setForm((current) => ({ ...current, [id]: value }));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (status === "sending") {
      return;
    }

    setStatus("sending");
    setFeedback("");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          message: form.message.trim(),
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || "Não foi possível enviar.");
      }

      setStatus("success");
      setFeedback("Mensagem enviada! Respondo em breve.");
      setForm(initialForm);
    } catch (error) {
      setStatus("error");
      setFeedback(
        error instanceof Error && error.message
          ? error.message
          : "Erro ao enviar. Tente novamente ou me chame por e-mail.",
      );
    }
  };

  const dismissToast = useCallback(() => setFeedback(""), []);

  const isSending = status === "sending";

  return (
    <>
      <section id="contato" className={styles["container"]}>
        <div className={styles["inner"]}>
          <div className={styles["content"]}>
            <span className={styles["label"]}>04 — Contato</span>
            <h2 className={styles["title"]}>Vamos construir algo juntos</h2>
            <p className={styles["description"]}>
              Estou aberto a novas oportunidades, freelas e conversas sobre
              produto e frontend. Me chame por e-mail ou pelas redes abaixo.
            </p>

            {/* <a
              href="contato.matheusbc7@gmail.com"
              className={styles["email"]}
            >
              contato.matheusbc7@gmail.com
            </a> */}

            <ul className={styles["socials"]}>
              {socials.map((social) => (
                <li key={social.label}>
                  <a
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["social"]}
                  >
                    <span className={styles["social-label"]}>
                      {social.label}
                    </span>
                    <span className={styles["social-handle"]}>
                      {social.handle}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <form className={styles["form"]} onSubmit={handleSubmit} noValidate>
            <div className={styles["field"]}>
              <label htmlFor="name">Nome</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Seu nome"
                value={form.name}
                onChange={handleChange}
                disabled={isSending}
                required
              />
            </div>

            <div className={styles["field"]}>
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="seu@email.com"
                value={form.email}
                onChange={handleChange}
                disabled={isSending}
                required
              />
            </div>

            <div className={styles["field"]}>
              <label htmlFor="message">Mensagem</label>
              <textarea
                id="message"
                name="message"
                rows={5}
                placeholder="Envie aqui sua mensagem"
                value={form.message}
                onChange={handleChange}
                disabled={isSending}
                required
              />
            </div>

            <Button
              type="submit"
              disabled={isSending}
              className={styles["submit"]}
            >
              {isSending ? "Enviando..." : "Enviar mensagem"}
            </Button>
          </form>
        </div>
      </section>

      {feedback && (
        <Toast
          variant={status === "success" ? "success" : "error"}
          message={feedback}
          onClose={dismissToast}
        />
      )}
    </>
  );
};

export default Contact;
